export const CUSTOMS_LINK_LABEL_SCAC = "Portbase NED";
